import { ReactNode } from "react";
import { Container, Stack, Typography, IconButton, Button } from "@mui/material";
import { useNavigate } from "react-router";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SettingsIcon from '@mui/icons-material/Settings';
import { Permiso } from "@/shared/types/permiso";
import useHasPermisos from "@/features/auth/hooks/useHasPermisos";
import { Dialog, ModalHeader, useOpenModal } from "@/components/modal";
import { DocumentoElectronicoSkeleton } from "@/components/skeletons/documento-electronico-skeleton";
import { ConfigRequiredAlert } from "./config-required-alert";
import { useEmisorConfig } from "../hooks/use-emisor-config";
import { TimbradoConfigSchemaForm } from "./timbrado-config-content";

interface DEPageLayoutProps {
    title: string;
    children: ReactNode;
}

export function DEPageLayout({
    title,
    children
}: DEPageLayoutProps) {
    const navigate = useNavigate();
    const openModal = useOpenModal();
    const hasConfigPermisos = useHasPermisos(Permiso.ManageConfiguracionFacturacionElectronica);
    const { isConfigValid, isLoading } = useEmisorConfig();

    return (
        <Container flex={1} component={Stack} maxWidth="xl" gap={2} paddingY={2}>
            <Stack direction={"row"} alignItems={"center"} gap={1}>
                <IconButton onClick={() => navigate(-1)} size="small">
                    <ArrowBackIcon />
                </IconButton>
                <Typography component={"h1"} variant="h5" flex={1}>
                    {title}
                </Typography>
                {hasConfigPermisos && (
                    <Button
                        variant="outlined"
                        startIcon={<SettingsIcon />}
                        onClick={() => openModal("timbradoConfig")}
                        size="small"
                        sx={{ height: 32 }}
                    >
                        Datos de Timbrado
                    </Button>
                )}
            </Stack>

            {/* Contenido principal */}
            {isLoading ? (
                <DocumentoElectronicoSkeleton />
            ) : !isConfigValid ? (
                <ConfigRequiredAlert />
            ) : (
                children
            )}

            <Dialog code="timbradoConfig" size="sm">
                <ModalHeader>Configuración de Timbrado</ModalHeader>
                <TimbradoConfigSchemaForm />
            </Dialog>
        </Container>
    );
}
